


































































































































































































































import auth from '@/mixins/auth';
import mixins from '@/utils/mixins';
import { IWorkflowFormSubmissionFetchParams } from '@/services';

import { PropType } from 'vue';
import {
  IWorkflowFormField,
  IWorkflowFormSectionField,
  IWorkflowFormTemplate,
  IWorkflowFormTemplateRevision,
  NO_OPTIONS_FIELD_TYPES,
  WorkflowFormFieldTypeEnum,
  WorkflowFormTemplateConfigHeaderTypeEnum
} from '@/models';

import NullableCheckbox from '../common/NullableCheckbox.vue';
import WorkflowFormTemplateStatesAutoCompletePicker from './WorkflowFormTemplateStatesAutoCompletePicker.vue';
import WorkflowFormTemplateUsersAutoCompletePicker from './WorkflowFormTemplateUsersAutoCompletePicker.vue';

interface CustomFilter {
      name: string;
      field: `meta_fields__${string}`;
      type: WorkflowFormFieldTypeEnum;
    }

export default mixins(auth).extend({
  name: 'WorkflowFormSubmissionSearchFilter',

  components: {
    NullableCheckbox,
    WorkflowFormTemplateStatesAutoCompletePicker,
    WorkflowFormTemplateUsersAutoCompletePicker
  },

  props: {
    open: {
      type: Boolean,
      default: false
    },

    formTemplate: {
      type: Object as PropType<IWorkflowFormTemplate>
    },

    publishedFormTemplateRevision: {
      type: Object as PropType<IWorkflowFormTemplateRevision>

    }
  },

  data() {
    return {
      filterParams: {} as IWorkflowFormSubmissionFetchParams,
      NO_OPTIONS_FIELD_TYPES
    };
  },

  computed: {
    openValue: {
      get(): boolean {
        return this.open;
      },
      set(val: boolean) {
        if (val === this.open) return;
        this.$emit('update:open', val);
      }
    },

    seriesIdPrefix(): string {
      const form = this.formTemplate;

      if (form) {
        return `${form.prefix}`;
      }

      return '';
    },

    customFilters(): CustomFilter[] {
      const metaLabels: CustomFilter[] = [];

      let sectionField = {} as IWorkflowFormSectionField;
      let sectionIndex = 0;

      if(!this.publishedFormTemplateRevision || !this.publishedFormTemplateRevision.sections) {
        return metaLabels;
      }

      while (sectionIndex < this.publishedFormTemplateRevision.sections!.length) {
        const sectionFields = this.publishedFormTemplateRevision.sections[sectionIndex]
          .section_fields;

        for (
          let sectionFieldIndex = 0;
          sectionFieldIndex < sectionFields.length;
          sectionFieldIndex++
        ) {
          sectionField = sectionFields[sectionFieldIndex];

          if ((sectionField.field_template as IWorkflowFormField).meta_label) {
            const formField = sectionField.field_template as IWorkflowFormField;

            const templateHeader = this.formTemplate!.config.headers.find(
              header => header.meta_label === formField.meta_label && header.type === WorkflowFormTemplateConfigHeaderTypeEnum.Table
            );

            if (templateHeader) {
              metaLabels.push({
                name: templateHeader.display_label,
                field: `meta_fields__${templateHeader.meta_label}`,
                type: formField.type
              });
            }
          }
        }
        sectionIndex++;
      }
      return metaLabels;
    }
  },

  methods: {
    closeSearchFilterDialog() {
      this.openValue = false;

      // reset filter params back to empty object
      this.resetFilterParams();
    },

    resetFilterParams() {
      this.filterParams = {};
    },

    openSearchFilterDialog(params: IWorkflowFormSubmissionFetchParams) {
      this.filterParams = params;

      if (params.form__template != null && !isNaN(params.form__template)) {
        this.filterParams.form__template = Number(params.form__template);
      }

      if (params.number != null && !isNaN(params.number)) {
        this.filterParams.number = Number(params.number);
      }

      if (params.state != null && !isNaN(params.state)) {
        this.filterParams.state = Number(params.state);
      }

      if (params.owner != null && !isNaN(params.owner)) {
        this.filterParams.owner = Number(params.owner);
      }

      if (params.is_urgent === undefined) {
        this.filterParams.is_urgent = params.is_urgent;
      }

      this.openValue = true;
    },

    save() {
      this.$emit('change', this.filterParams);
      this.closeSearchFilterDialog();
    }
  }
});
